import React from 'react'
import clsx from 'clsx'
import { Body2 } from '../../MaterialUi/Typo/Body'
import { useStyle } from './Style'
import { ContentHelpProps } from './Type'

export const ContentHelp: React.FC<React.PropsWithChildren<ContentHelpProps>> = ({
  children,
  className,
  style,
  icon,
  severity,
}): React.ReactElement => {
  const classes = useStyle()

  return (
    <div
      className={clsx(classes.cards, className, severity && classes[severity])}
      style={style}
      data-testid="contentHelp"
    >
      {icon && <div className={classes.icon}>{icon}</div>}
      <Body2 className={classes.content}>{children}</Body2>
    </div>
  )
}

export default ContentHelp
